<script setup>
// NOOVI: lista de resultados de busca para Follow-ups (Gap FU-B — fase-11).
import { useMapGetter } from 'dashboard/composables/store.js';

import SearchResultSection from './SearchResultSection.vue';
import SearchResultFollowUpItem from './SearchResultFollowUpItem.vue';

defineProps({
  followUps: {
    type: Array,
    default: () => [],
  },
  query: {
    type: String,
    default: '',
  },
  isFetching: {
    type: Boolean,
    default: false,
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
});

const accountId = useMapGetter('getCurrentAccountId');
</script>

<template>
  <SearchResultSection
    :title="$t('SEARCH.SECTION.FOLLOW_UPS')"
    :empty="!followUps.length"
    :query="query"
    :show-title="showTitle"
    :is-fetching="isFetching"
  >
    <ul v-if="followUps.length" class="space-y-3 list-none">
      <li v-for="followUp in followUps" :key="followUp.id">
        <SearchResultFollowUpItem
          :title="followUp.title"
          :status="followUp.status"
          :contact-name="followUp.contact && followUp.contact.name"
          :account-id="accountId"
          :created-at="followUp.createdAt"
        />
      </li>
    </ul>
  </SearchResultSection>
</template>
